import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDownload, faSpinner} from '@fortawesome/pro-regular-svg-icons';

import {IRelatedPartiesSubStepProps} from '../companyDetails.types';

const RelatedPartiesSubStep: React.FC<IRelatedPartiesSubStepProps> = ({
  relatedParties,
  busyReportId,
  onDownloadPartyCreditReport,
}) => (
  <div className="company-related-grid">
    {relatedParties.length > 0 ? (
      relatedParties.map((party) => (
        <article key={party.id} className="company-related-card">
          <header>
            <h4>{party.title}</h4>
            <button
              type="button"
              className="link-button"
              onClick={() => {
                void onDownloadPartyCreditReport(party);
              }}
              disabled={
                !party.idNumber ||
                busyReportId === party.id ||
                busyReportId !== null
              }
            >
              <FontAwesomeIcon
                icon={busyReportId === party.id ? faSpinner : faDownload}
                spin={busyReportId === party.id}
              />
              {busyReportId === party.id ? 'Downloading…' : 'Credit report'}
            </button>
          </header>
          <dl>
            <div>
              <dt>ID number</dt>
              <dd>{party.idNumber}</dd>
            </div>
            <div>
              <dt>Phone</dt>
              <dd>{party.phone}</dd>
            </div>
            <div>
              <dt>Credit score</dt>
              <dd>{party.creditScore}</dd>
            </div>
            <div>
              <dt>Address</dt>
              <dd>{party.address}</dd>
            </div>
          </dl>
        </article>
      ))
    ) : (
      <div className="company-info-panel">
        <p>
          No related parties were found for this supplier trading profile yet.
          Refresh this section after the supplier trading form is synced.
        </p>
      </div>
    )}
  </div>
);

export default RelatedPartiesSubStep;

export {RelatedPartiesSubStep};
